/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Ipmi
 */
export interface Ipmi {
    /**
     * 
     * @type {string}
     * @memberof Ipmi
     */
    ip: string;
    /**
     * 
     * @type {string}
     * @memberof Ipmi
     */
    netmask: string;
    /**
     * 
     * @type {string}
     * @memberof Ipmi
     */
    gateway: string;
}

export function IpmiFromJSON(json: any): Ipmi {
    return IpmiFromJSONTyped(json, false);
}

export function IpmiFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ipmi {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ip': json['ip'],
        'netmask': json['netmask'],
        'gateway': json['gateway'],
    };
}

export function IpmiToJSON(value?: Ipmi | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ip': value.ip,
        'netmask': value.netmask,
        'gateway': value.gateway,
    };
}


